import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'

@inject('messageManagementStore')
@observer
class MessageManagement extends Component {
    render() {
      const { messageManagementStore,location } = this.props
      const { isFetching } = messageManagementStore
      return (
        <Spin spinning={isFetching}>
          <div className="container">
            <SearchForm searchParams={location?.state?.searchParams} location={location} />
            <SearchResult />
          </div>
        </Spin>
      );
    }
}
export default MessageManagement;
